import { useFormik } from 'formik';
import { useEffect } from 'react';
import React from 'react';
import { Redirect } from 'react-router';

import { useAppSelector } from '@app/redux/hooks';
import { getMFAPreconditionData } from '@app/redux/mfa/mfa.selectors';
import RoutePaths from '@app/routes/paths';
import useGenerateRoutePath from '@app/routes/paths/useGenerateRoutePath';

import { VerifyEmailContainer } from '@components/forms/verifyEmail';
import { VerifyEmailFormValues } from '@components/forms/verifyEmail/interfaces';
import verifyEmailFormValidationScheme from '@components/forms/verifyEmail/validationScheme';

import MFA_METHODS_ENUM from '@pages/Verification/MFASetupPage/enums/MFA_METHODS.enum';

import { use2FALogin } from '../../use2FALogin';

function Email2FA({ onDecline }: { onDecline?: () => void }) {
	const { login, sendMFACode, isSendingMFACode } = use2FALogin({ method: MFA_METHODS_ENUM.EMAIL });
	const mfaPreconditionData = useAppSelector(getMFAPreconditionData);
	const generateRoutePath = useGenerateRoutePath();
	const formik = useFormik<VerifyEmailFormValues>({
		validationSchema: verifyEmailFormValidationScheme,
		initialValues: { code: '' },
		onSubmit: login,
	});

	useEffect(() => {
		sendMFACode();
	}, []);

	return mfaPreconditionData ? (
		<VerifyEmailContainer
			isSendingVerificationEmailCode={isSendingMFACode}
			handleSendVerificationEmailCode={sendMFACode}
			onDecline={onDecline}
			email={mfaPreconditionData.email}
			formik={formik}
		/>
	) : (
		<Redirect to={generateRoutePath(RoutePaths.AUTH.LOGIN)} />
	);
}

export default Email2FA;
